var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-filters" },
    [
      _c(
        "mobile-multiselect-item",
        {
          attrs: { title: "Сортировать" },
          nativeOn: {
            click: function($event) {
              return _vm.$emit("select", "sort")
            }
          }
        },
        [
          _c("div", { staticClass: "panel-filters__item-value" }, [
            _vm._v("\n      " + _vm._s(_vm.sortTitle) + "\n    ")
          ])
        ]
      ),
      _vm._l(_vm.filters, function(filter) {
        return _c(
          "mobile-multiselect-item",
          {
            key: filter.id,
            staticClass: "panel-filters__item",
            attrs: { title: filter.name },
            nativeOn: {
              click: function($event) {
                return _vm.$emit("select", filter.id)
              }
            }
          },
          [
            _vm.isCount(filter.id)
              ? _c("ui-badge", {
                  attrs: { text: _vm.getFilterValue(filter.id).length }
                })
              : _c(
                  "div",
                  { staticClass: "panel-filters__item-value" },
                  [
                    _vm.isPrice(filter.id)
                      ? [
                          _vm._v("\n        от\n        "),
                          _c("price", {
                            attrs: { value: _vm.priceValue.from }
                          }),
                          _vm._v("\n        до\n        "),
                          _c("price", { attrs: { value: _vm.priceValue.to } })
                        ]
                      : [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.getItemLabel(filter.id)) +
                              "\n      "
                          )
                        ]
                  ],
                  2
                )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }